import { MarkerData, MarkerWithDetails } from "./map";

export function initGroups(map: google.maps.Map, openPopup: (marker: MarkerWithDetails) => Promise<void>) {

  const url = '/teaching_groups/issue.json';
  const suffix = 'Groups';

  let markers: MarkerWithDetails[] = [];
  let filter: string = '';

  async function fetchMarkers() {
    const response = await fetch(`${url}?${filter}`);
    const data = await response.json();
    console.log(`${url} => ${data.length}`);
    $('#counter' + suffix).text(data.length);

    markers.forEach(marker => marker.map = null);
    markers = [];

    markers = data.map((data: MarkerData) => {
      const container = document.createElement("div");
      const img = document.createElement("img");
      img.src = data.icon;
      img.width = 22;  // adjust size
      img.height = 40;
      img.style.display = "block";
      container.appendChild(img);

      const label = document.createElement("div");
      label.classList.add('map-labels');
      label.innerText = data.title;
      container.appendChild(label);

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: {
          lat: data.lat,
          lng: data.lon
        },
        title: data.title,
        content: container
      }) as MarkerWithDetails;

      marker.labelEl = label;
      marker.details_url = data.details_url;
      marker.addListener("gmp-click", async () => {
        openPopup(marker);
      });

      return marker;
    });
    refresh();
  }

  let suppressFiltering = false;

  $('#toggleMap' + suffix).on('click', function (e) {
    $(this).toggleClass('active');
    $(this).blur();
    refresh();
  });

  function refresh() {
    markers.forEach(marker => {
      marker.map = $('#toggleMap' + suffix).hasClass('active') ? map : null;
      marker.labelEl.style.display = $('#toggleMapLabels').hasClass('active') ? "block" : "none";
    });
  }

  fetchMarkers();
}